@if (routerLink && !disabled) {
	<a
		[routerLink]="routerLink"
		[ngClass]="getButtonClasses()"
		class="custom-button"
		role="button"
		[attr.aria-label]="ariaLabel || null"
		[attr.aria-disabled]="disabled || loading">
		@if (loading) {
			<span class="spinner"></span>
		}
		@if (icon && !loading) {
			<lucide-icon [name]="icon" class="custom-icon" aria-hidden="true"></lucide-icon>
		}
		@if (label) {
			<span class="button-label">{{ label }}</span>
		}
	</a>
} @else {
	<button
		[type]="type"
		[disabled]="disabled || loading"
		[ngClass]="getButtonClasses()"
		[class.loading]="loading"
		[attr.aria-label]="ariaLabel || null"
		[attr.aria-busy]="loading || null"
		class="custom-button"
		(click)="handleClick($event)">
		@if (loading) {
			<span class="spinner"></span>
		}
		@if (icon && !loading) {
			<lucide-icon [name]="icon" class="custom-icon" aria-hidden="true"></lucide-icon>
		}
		@if (label) {
			<span class="button-label">{{ label }}</span>
		}
	</button>
}